export const DEFAULT_CALL_SOUND_KEY = 'default';
export const CALL_SOUND_ENABLED_STORAGE_KEY = 'callSoundEnabled';
export const CALL_SOUND_STORAGE_KEY = 'callSoundKey';

export const CALL_SOUND_OPTIONS = [
	{
		key: 'default',
		name: '默认通话铃声',
		src: require('@/assets/audio/call.wav')
	},
	{
		key: 'classic',
		name: '经典电话铃声',
		src: require('@/assets/audio/call-classic.wav')
	},
	{
		key: 'digital',
		name: '数字来电',
		src: require('@/assets/audio/call-digital.wav')
	},
	{
		key: 'melody',
		name: '轻快旋律',
		src: require('@/assets/audio/call-melody.wav')
	},
	{
		key: 'soft',
		name: '柔和铃声',
		src: require('@/assets/audio/call-soft.wav')
	}
];

export function getCallSoundOption(key) {
	return CALL_SOUND_OPTIONS.find(item => item.key === key) || CALL_SOUND_OPTIONS[0];
}
